import { CalendarHeader, ModalTabs, Show, TableComponent, Tabs } from "components"
import { useEffect, useState } from "react"

import UnapprovedEndorsements from "./tabs/endorsements"
import UnapprovedOffers from "./tabs/offers"
import UnapprovedTreaties from "./tabs/treaties"
import { useMount } from "react-use"
import { useUrlState } from "utils"

type Props = {}

const UnapprovedClosingsPage = (props: Props) => {
    const [orderStatus, setOrderStatus] = useUrlState<string>("offers",)

    useMount(() => {
        if (!orderStatus) {
            setOrderStatus("offers")
        }
    })

    return (
        <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
            <CalendarHeader />
            <ModalTabs tabs={[
                {
                    name: "Offers",
                    href: "offers",
                },
                {
                    name: "Treaties",
                    href: "treaties",
                },
                {
                    name: "Endorsements",
                    href: "endorsements",
                },
            ]}
                orderStatus={orderStatus} setOrderStatus={setOrderStatus} />
            <div className="flex flex-1 overflow-y-auto">
                <div className="flex-1 mx-auto min-w-0  py-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
                    <Show if={orderStatus === "offers"}>
                        <UnapprovedOffers />
                    </Show>
                    <Show if={orderStatus === "treaties"}>
                        <UnapprovedTreaties />
                    </Show>
                    <Show if={orderStatus === "endorsements"}>
                        <UnapprovedEndorsements />
                    </Show>
                </div>
            </div>
        </main>
    )
}

export default UnapprovedClosingsPage